export default function StatusBadge({ value }) {
  const v = String(value || "").toLowerCase();
  const tone = v.includes("deliv")
    ? "green"
    : v.includes("ready")
    ? "amber"
    : v.includes("partial")
    ? "blue"
    : v.includes("paid") && !v.includes("un")
    ? "green"
    : v.includes("unpaid")
    ? "amber"
    : "blue";
  return <span className={`status ${tone}`} data-testid="status-badge">{value}</span>;
}
